import { Section, SectionHeader } from './Section';
import { IAccordionSectionEntry } from '../../../../contentful';
import {
	Accordion,
	AccordionItem,
} from '../../../../components/common/accordion';
import { getListedEntryKey } from '../../../../utils/getListedEntryKey';
import { IQuickLinkItem, Markdown } from '../../../../ui';
import renderQuickLinkItem from '../../domain/use-cases/renderQuickLinkItem';
import { getLinkItemForEntry } from '../../domain/use-cases/getLinkItemForEntry';
import { useCommonData } from '../../../../common-data/useCommonData';

export interface IAccordionSectionProps {
	id: string;
	section: IAccordionSectionEntry;
}

export function AccordionSection({ section, id }: IAccordionSectionProps) {
	const { pathToPageIdMap } = useCommonData();
	return (
		<Section id={id}>
			{section.fields.title && (
				<SectionHeader styling="h4">{section.fields.title}</SectionHeader>
			)}
			<Accordion>
				{section.fields.items &&
					section.fields.items.map((item, index) => {
						const { title, body, link } = item.fields;

						const quickLink = link && {
							...getLinkItemForEntry(link, index, pathToPageIdMap),
						};

						return (
							<AccordionItem key={getListedEntryKey(item, index)} title={title}>
								<Markdown source={body} />
								{quickLink && renderQuickLinkItem(quickLink as IQuickLinkItem)}
							</AccordionItem>
						);
					})}
			</Accordion>
		</Section>
	);
}
